import cx from 'classnames';

/**
 *
 * @returns Presentational markup for affiliate logos
 */
const Affiliates = ({ isAddYMargin = false }) => {
  return (
    <section
      className={cx('my-0 mx-auto container-affiliates', {
        'my-12': isAddYMargin,
      })}
    >
      <div className="bg-white container-md h-1 mb-8 radius-full" role="presentation" />
      <div className="flex flex-wrap gap-y-4 md:flex-row md:py-32 py-12">
        <div className="align-center flex justify-center md:w-quarter w-half">
          <img alt="Mark Hughes Foundation logo" className="md:w-52 w-24" loading="lazy" src="/images/mark-hughes-foundation-logo.png" />
        </div>

        <div className="align-center flex justify-center md:w-quarter w-half">
          <img alt="Mental Health Innovation Team logo" className="md:w-52 w-24" loading="lazy" src="/images/MHIT.png" />
        </div>

        <div className="align-center flex justify-center md:w-quarter w-half">
          <img alt="Hunter Medical Research Institute logo" className="md:w-52 w-24" loading="lazy" src="/images/hmri-logo.png" />
        </div>

        <div className="align-center flex justify-center md:w-quarter w-half">
          <img alt="University of Newcastle logo" className="md:w-32 w-24" loading="lazy" src="/images/university-of-newcastle-logo.svg" />
        </div>
      </div>
    </section>
  );
};

export { Affiliates };
